<template>
  <div>
    <div v-if="this.loadingFormSubmit == true" class="loader">Loading...</div>

    <el-dialog 
      v-if="this.loadingFormSubmit == false"
      :width="dialogWidth" 
      title="Delete asset" 
      :visible.sync="dialogFormVisible" 
      :close-on-click-modal="false"
      @close="closeForm()" 
      :modalAppendToBody="false"
    >
    
    <div class="parent" >

  <div>
    <h1>Delete Role</h1>

    <h4>Are you sure you want to delete?</h4>
    <h5>This action cannot be undone.</h5>
  </div>


<div class="new-role">
    <h3> Please choose a new role for all users with "{{roleToDelete.rolename}}" role</h3>
      <el-dropdown @command="selectRole" trigger="click">
        <el-button type="primary">
        {{selectedRole}}<i class="el-icon-arrow-down el-icon--right"></i>
        </el-button>
        <el-dropdown-menu   slot="dropdown">
            <el-dropdown-item v-for="role in this.allRoles" :command="role" :key="role.roleid">
              {{role.rolename}}
              <p style="  font-style: italic; font-size: 12px; float: right; margin:0;" v-if="role.customrole == false"> default </p>
            </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
</div>
</div>

<div>
    <el-button class="tst-confirm-delete-button" type="danger" text  @click="deleteAsset()" >Delete Role</el-button>
    <el-button class="tst-cancel-delete-button" text @click="closeForm()">Cancel</el-button>
  </div>
 </el-dialog>

  </div>
</template>

<script>
import EventService from "@/services/EventService.js";
export default {
  props: {
    allRoles: Array,
    roleToDelete: Object
  },
  data() {
    return {
      dialogFormVisible: true,
      dialog: false,
      dialogWidth: "fit-content",
      selectedRole: this.allRoles[0].rolename,
      addRoleId: "",
      loadingFormSubmit: false
    };
  },
  mounted(){
      this.addRoleId = this.allRoles[0].roleid;

      var x = window.matchMedia("(max-width: 979px)");
              if (x.matches) {
              this.dialogWidth = "100%"
              }
  },
  methods: {
    deleteAsset() {

      this.loadingFormSubmit = true;

      EventService.deleteRole(this.roleToDelete.roleid, this.addRoleId )
        .then( response => {
           
           this.$store.dispatch("addNotification", {
              type: "success",
              Message: "Role deleted"
            })
             
             this.$emit("role-deleted", this.roleToDelete)
             this.closeForm();
        })
        .catch(error => {
            console.log(error);
            this.closeForm();
        });

    },
   selectRole(role){
      this.selectedRole = role.rolename;
      this.addRoleId = role.roleid;
    },
    closeForm() {
      this.$emit("close-delete-form");
    }
  }
};
</script>

<style scoped>
.new-role{
   margin-left: 150px;
   word-break: keep-all;
}
.parent{
  display:flex;
}
@media (min-width: 250px) and (max-width: 979px) {

.new-role{
    margin: 45px;
}
.parent{
  display: unset;
}

}
</style>
